(function () {
  function init() {
    var toggle = document.querySelector('.etq-grid-toggle');
    var grid = document.getElementById('product-grid');

    // --- Sort (drawer mode): Dawn doesn't wire the desktop sort, so navigate manually ---
    if (!document.__etqSortNav) {
      document.__etqSortNav = true;
      document.addEventListener('change', function (e) {
        var s = e.target;
        if (!s || s.name !== 'sort_by') return;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', s.value);
        url.searchParams.delete('page');
        // Defer so we don't collide with any in-flight handler
        setTimeout(function () { window.location.href = url.toString(); }, 0);
      });
    }

    if (!toggle || !grid) return;

    // Default state: multi-column (unless single is already set)
    if (!grid.classList.contains('etq-grid--single')) {
      grid.classList.add('etq-grid--multi');
    }

    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('.etq-grid-toggle__btn');
      if (!btn) return;
      var view = btn.getAttribute('data-view');

      toggle.querySelectorAll('.etq-grid-toggle__btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      grid.classList.toggle('etq-grid--single', view === 'single');
      grid.classList.toggle('etq-grid--multi', view === 'multi');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () {
    var g = document.getElementById('product-grid');
    if (g && !g.__etqBound) { g.__etqBound = true; init(); }
  }).observe(document.body, { childList: true, subtree: true });
})();